import React, { useEffect } from "react";
import {
  DownloadIcon,
  InfoIcon,
  LogOutIcon,
  MenuIcon,
  OpenLinkIcon,
} from "../components/baseComponents/Icons";
import { env } from "../environments";
import { postToServer } from "../store/utils/postToServer";
import styles from "./Footer.module.scss";
import { getVersion } from "../jsxProviders/helpers/tmpDir";
type Props = {
  signOut: () => void;
  environment: string;
};
const Footer = ({ signOut, environment }: Props) => {
  const [version, setVersion] = React.useState<string | undefined>(undefined);
  useEffect(() => {
    const loadVersion = async () => {
      try {
        const jsxVersion = await getVersion();
        setVersion(jsxVersion);
      } catch (e) {
        console.log(e);
      }
    };
    loadVersion();
  }, []);
  return (
    <div className={styles.Bar}>
      <div
        className={[styles.LogOut, styles.Action].join(" ")}
        onClick={signOut}
      >
        <LogOutIcon /> Logout
      </div>
      <div
        className={styles.Action}
        onClick={() => {
          postToServer("openUrl", {
            url: env[environment].platform,
          });
        }}
      >
        <OpenLinkIcon view="footer" /> Platform
      </div>
      <div
        className={styles.Action}
        onClick={() => {
          postToServer("openUrl", {
            url: "https://help.blings.io/creator",
          });
        }}
      >
        <InfoIcon /> Support
      </div>
      <div className={styles.Right}>
        <div
          className={styles.Action}
          onClick={() => {
            postToServer("openUrl", {
              url: env[environment].latestVersionDownload,
            });
          }}
        >
          <DownloadIcon /> {version || "Latest"}{" "}
        </div>
        <div
          className={styles.Menu}
          onClick={() => {
            postToServer("openUrl", {
              url: "https://www.blings.io/",
            });
          }}
        >
          <MenuIcon view="footer" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
